import { useCallback } from "react";
import * as React from "react";

import { ColLabel } from "components/light-table";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { ILiveChatAgent, ISort } from "store/views/agents";

import LiveChatAgentRow from "./LiveChatAgentRow";
import { AgentLightTable, AgentLightTableHead, AgentLightTableWrapper, ColumnWidths } from "./styled";

interface IProps extends IWithBreakpointsProps {
  sort: ISort;
  agents: ILiveChatAgent[];
  canImportLiveChatAgents: boolean;
  onSort(field: string, desc: boolean): void;
  onLiveChatAgentImportClick(agentEmail: string): void;
}

const LiveChatAgentsList: React.FC<IProps> = ({
  sort,
  agents,
  isMobile,
  canImportLiveChatAgents,
  onSort,
  onLiveChatAgentImportClick,
}) => {
  const handleLiveChatAgentImportClick = useCallback(
    (agentEmail: string) => {
      onLiveChatAgentImportClick(agentEmail);
    },
    [onLiveChatAgentImportClick]
  );

  return (
    <>
      <AgentLightTableHead>
        <thead>
          <tr>
            <th style={{ width: ColumnWidths.Avatar }} />
            <th>
              <ColLabel active={sort.field === "name"} desc={sort.desc} onClick={() => onSort("name", !sort.desc)}>
                Name
              </ColLabel>
            </th>
            <th style={{ width: ColumnWidths.LiveChatRole }}>
              <ColLabel active={sort.field === "role"} desc={sort.desc} onClick={() => onSort("role", !sort.desc)}>
                LiveChat Role
              </ColLabel>
            </th>
            {!isMobile && (
              <th style={{ width: ColumnWidths.Actions }}>
                <ColLabel>Action</ColLabel>
              </th>
            )}
          </tr>
        </thead>
      </AgentLightTableHead>
      <AgentLightTableWrapper>
        <AgentLightTable>
          <tbody>
            {agents.map((agent: ILiveChatAgent) => (
              <LiveChatAgentRow
                key={agent.email}
                agent={agent}
                canImportLiveChatAgents={canImportLiveChatAgents}
                onImportClick={handleLiveChatAgentImportClick}
              />
            ))}
          </tbody>
        </AgentLightTable>
      </AgentLightTableWrapper>
    </>
  );
};

export default withBreakpoints(LiveChatAgentsList);
